import * as React from "react";
import type { SVGProps } from "react";
const SvgGlobe02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m19.2 18.35-3.508-4.135h-2.215L12 12.74l2.954-4.431h5.17M6.83 4.615l1.566 1.567a2.976 2.976 0 0 1-2.104 5.08H3.138M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgGlobe02;
